<umss-dialog
  [open]="open"
  [size]="'Large'"
  [closable]="true"
  [backdropClosable]="true"
  (onClose)="onCancel()"
>
  <umss-dialog-header
    [title]="'Select ID Batch'"
    [subtitle]="'Choose a batch from storage to load'"
    [showCloseButton]="true"
    (onClose)="onCancel()"
  />

  <div class="selector-content">
    <!-- Loading State -->
    <div *ngIf="isLoading()" class="loading-state">
      <p>Loading batches...</p>
    </div>

    <!-- Error State -->
    <div *ngIf="errorMessage()" class="error-state">
      <p class="error-message">{{ errorMessage() }}</p>
    </div>

    <!-- Batches List -->
    <div *ngIf="!isLoading() && batches().length > 0" class="batches-list">
      <div
        *ngFor="let batch of batches(); let i = index"
        class="batch-item"
        [ngClass]="{ selected: selectedBatchIndex() === i }"
        (click)="selectBatch(i)"
      >
        <div class="batch-header">
          <div class="batch-info">
            <span class="batch-time">{{ batch.formattedTime }}</span>
            <span class="batch-date">{{ formatDate(batch.savedAt) }}</span>
            <span class="batch-count">{{ batch.count }} ID(s)</span>
          </div>
          <div class="batch-radio">
            <input
              type="radio"
              [checked]="selectedBatchIndex() === i"
              (change)="selectBatch(i)"
              [attr.aria-label]="'Select batch ' + i"
            />
          </div>
        </div>

        <!-- Selected Batch Details -->
        <div *ngIf="selectedBatchIndex() === i" class="batch-details">
          <div class="ids-preview">
            <p class="ids-label">IDs in this batch:</p>
            <div class="ids-list">
              <span *ngFor="let id of batch.ids" class="id-tag">{{ id }}</span>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Empty State -->
    <div
      *ngIf="!isLoading() && batches().length === 0 && !errorMessage()"
      class="empty-state"
    >
      <p>No batches found</p>
    </div>
  </div>

  <umss-dialog-footer
    [secondaryButtonLabel]="'Cancel'"
    [primaryButtonLabel]="'OK'"
    [primaryButtonDisabled]="!isValid()"
    (onSecondaryClick)="onCancel()"
    (onPrimaryClick)="onConfirm()"
  />
</umss-dialog>
